import React from "react";
import reflect from "../../translate/translations";
import "./Footer.scss";

export const Footer = () => {
  return (
    <div className="footer-com">
      <div className="container">
        <div className="row">
          <div className="col-md-6 col-xs-12 col-lg-6">
            <div className="oao">
              {`© ${new Date().getFullYear()} ${reflect.t("alif_bank")}`}
            </div>
          </div>
          <div className="col-md-6 col-xs-12 col-lg-6">
            <div className="license">{reflect.t("license")}</div>
          </div>
        </div>
      </div>
    </div>
  );
};
